import React from 'react';
import {
  AgnesSheet,
  AgnesSheetContent,
  AgnesSheetHeader,
  AgnesSheetTitle,
  AgnesDataTable,
} from '@agnes/ui';
import { EmptyState } from '@/components/ui/EmptyState';
import type { StoreApi, UseBoundStore } from 'zustand';

type Row = { [k: string]: any };

type Store = UseBoundStore<StoreApi<any>>;

const nomeDe = (v: any) => (v && typeof v === 'object' ? (v.name ?? '-') : '-');

export default function DrawerIncidenciaHistorico({
  open,
  onClose,
  useStore,
}: {
  open: boolean;
  onClose: () => void;
  useStore: Store;
}) {
  const historico = useStore((s: any) => s.historico) as Row[];

  const columns = [
    { key: 'de', header: 'De', width: 220, render: (r: Row) => nomeDe(r.fromValue) },
    { key: 'para', header: 'Para', width: 220, render: (r: Row) => nomeDe(r.toValue) },
    { key: 'updatedBy', header: 'Por', width: 160, render: (r: Row) => r.updatedBy ?? '-' },
    { key: 'updatedAt', header: 'Quando', width: 180, render: (r: Row) => r.updatedAt ?? '-' },
  ];

  return (
    <AgnesSheet
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <AgnesSheetContent side="right" className="flex w-full max-w-2xl flex-col p-0 sm:w-[640px]">
        <AgnesSheetHeader className="border-b border-agnes-border px-4 py-3">
          <AgnesSheetTitle>Histórico da incidência</AgnesSheetTitle>
        </AgnesSheetHeader>
        <div className="flex-1 overflow-auto p-4">
          {historico.length === 0 ? (
            <EmptyState title="Nenhuma alteração registrada" />
          ) : (
            <div className="overflow-x-auto">
              <AgnesDataTable<Row>
                columns={columns}
                data={historico}
                rowKey={(r) => String(r.id)}
              />
            </div>
          )}
        </div>
      </AgnesSheetContent>
    </AgnesSheet>
  );
}
